import React from 'react';

// type ContextType = {
//   UserFrom: string,
//   UserId: string,
//   UserRole: string,
//   name: string
// };

const Context = React.createContext();

// type Props = {
//   children: Node,
//   context: ContextType
// };

const ContextProvider = ({ children, ...context }) => (
  <Context.Provider value={context}>{children}</Context.Provider>
);

const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component';

export const withContext = (Component) => {
  const ConnectedComponent = (props) => (
    <Context.Consumer>{(context) => <Component {...props} {...context} />}</Context.Consumer>
  );

  ConnectedComponent.displayName = `WithContext(${getDisplayName(Component)})`;

  return ConnectedComponent;
};

export default ContextProvider;
